module.exports = __webpack_public_path__ + "media/images/online-fc3abf00a40df8f3ebf1a726afcf8b5f.svg";